import React from "react"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import Footer from './Footer';
import { useEffect, useState } from "react"
import axios from "axios";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {Link, Route, Routes} from 'react-router-dom';
import Nav from './Nav';








const error = (text) => {
  toast.error(text, {
    position: toast.POSITION.TOP_RIGHT
});
};

const success = (text) => {
  toast.success(text, {
    position: toast.POSITION.TOP_RIGHT
});
};





export default function Panels(props){
  const [panels, setItems] = useState([])
 
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [name, setName] = useState();
  const [watt, setWatt] = useState(0);
  const [cost, setCost] = useState(0);
  const [length, setLength] = useState(0);
  const [breadth, setBreadth] = useState(0);

  




  const fetch_panels = async () => {
    const result = await axios("https://api.tydacomm.com/api/user/panels");
    setItems(result.data.data);
  };

  const add_panel = () => {
    
    axios
      .post("https://api.tydacomm.com/api/user/create-panel", {
        name: name,
        watt: watt,
        cost: cost,
        length: length,
        breadth: breadth
      })
      .then((response) => {
        
        if(response.data.error){
          error(response.message);
        }else{
          success(response.message)
        }
        
        fetch_panels()
      });

      

      

      handleClose();
      
     
      
  }

  
   
  

  useEffect(() => {
    fetch_panels()
  }, []);


 

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
     






return (
  <div id="wrapper">
      <Header isSidebarOpen={isSidebarOpen} />
      <ToastContainer />
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          
        <Nav  toggleSidebar={toggleSidebar}/>
  

    
    <div class="container-fluid">
    

          <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Panel to Pool</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <div class="form-group">
            <input type="text" class="form-control form-control-user" id="name"
              placeholder="Panel Name"   onChange={e => setName(e.target.value)} />
          </div>

          <div class="form-group">
            <input type="number" class="form-control form-control-user" id="watt"
              placeholder="Panel Watt"   onChange={e => setWatt(e.target.value)} />
          </div>

          <div class="form-group">
            <input type="number" class="form-control form-control-user" id="cost"
              placeholder="Panel Cost(₦)"   onChange={e => setCost(e.target.value)} />
          </div>


          <div class="form-group">
            <input type="number" class="form-control form-control-user" id="length"
              placeholder="Length"   onChange={e => setLength(e.target.value)} />
          </div>

          <div class="form-group">
            <input type="number" class="form-control form-control-user" id="breadth"
              placeholder="Breadth"   onChange={e => setBreadth(e.target.value)} />
          </div>
          


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={add_panel}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    


    <span style={{float:"right"}}>
    <button class='btn btn-primary' onClick={handleShow}>Add New Item</button>
    </span>


        <h1 class="h3 mb-4 text-gray-800">Solar Panels</h1>
        <table class="table table-striped dataTable">
          <thead>
            <tr>
              <th>S/N</th>
              <th>Name</th>
              <th>Watt</th>
              <th>Cost(₦)</th>
              <th>Length(mm)</th>
              <th>Breadth(mm)</th>

            </tr>
          </thead>
          <tbody>
          {panels.map(panel => (
              <tr key={panel.id}>
                <td>{panel.id}</td>
                <td>{panel.name}</td>
                <td>{panel.watt}</td>
                <td>{panel.cost.toLocaleString()}</td>
                <td>{panel.length}</td>
                <td>{panel.breadth}</td>
              </tr>
            ))}
          
          </tbody>
        </table>

    </div>
   

</div>



<Footer />

</div>
    </div>
  
        
      )
}





 